import { Input } from '@/shared/components/ui/input'
import { Textarea } from '@/shared/components/ui/textarea'
import { CharacterVariant } from '@storyverse/shared'
import { FormField } from './FormField'
import React from 'react'

interface VariantPersonalityTabProps {
    variant: CharacterVariant
    updateVariant: (id: string, updates: Partial<CharacterVariant>) => void
}

export const VariantPersonalityTab: React.FC<VariantPersonalityTabProps> = ({ variant, updateVariant }) => {
    return (
        <div className="space-y-6 pt-4">
            <FormField label="Internal Monologue / Core Traits" helperText="Deeper psychological makeup.">
                <Textarea
                    value={variant.core_personality_traits || ''}
                    onChange={e => updateVariant(variant.id, { core_personality_traits: e.target.value })}
                    rows={3}
                    className="bg-background border-primary/10 transition-all focus:border-primary/40 text-sm leading-relaxed"
                />
            </FormField>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <FormField label="Strengths" helperText="What are they good at?">
                    <Input value={variant.strengths || ''} onChange={e => updateVariant(variant.id, { strengths: e.target.value })} className="h-10" />
                </FormField>
                <FormField label="Flaws" helperText="What holds them back?">
                    <Input value={variant.flaws || ''} onChange={e => updateVariant(variant.id, { flaws: e.target.value })} className="h-10" />
                </FormField>
                <FormField label="Motivations" helperText="Why do they do what they do?">
                    <Input value={variant.motivations || ''} onChange={e => updateVariant(variant.id, { motivations: e.target.value })} className="h-10" />
                </FormField>
                <FormField label="Fears" helperText="What keeps them up at night?">
                    <Input value={variant.fears_insecurities || ''} onChange={e => updateVariant(variant.id, { fears_insecurities: e.target.value })} className="h-10" />
                </FormField>
            </div>
        </div>
    )
}
